<template>
  <div>
    <p v-if="attachment.metadata.old">
      Status changed from <span class="badge" :class="getBadge(attachment.metadata.old)">{{ attachment.metadata.old }}</span> to <span class="badge" :class="getBadge(attachment.metadata.new)">{{ attachment.metadata.new }}</span>
    </p>
    <p v-else>
      Status set to <span class="badge" :class="getBadge(attachment.metadata.new)">{{  attachment.metadata.new }}</span>
    </p>
  </div>
</template>

<script>
  export default {
    props: {
      attachment: {
        type: Object,
        default: function () {
          return {};
        }
      }
    },
    methods: {
      getBadge(status) {
        switch (status) {
          case 'New':
            return 'badge-danger';
          case 'Open':
            return 'badge-info';
          case 'Resolved':
            return 'badge-success';
        }
      }
    },
  }
</script>